import { Component, OnInit, inject, Output, EventEmitter, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { StatusService } from '../../services/status.service';
import { AppSettings } from '@services/settings/app-settings.service';
import { ListCardComponent } from 'app/core/components/list-card/list-card.component';
import { MobileFooterComponent } from 'app/core/components/mobile-footer/mobile-footer.component';
import { BottomSheetComponent } from 'app/core/components/bottom-sheet/bottom-sheet.component';
import { PermissionService } from '@services/core/permission.service';

@Component({
  selector: 'app-status-list',
  standalone: true,
  imports: [CommonModule, NgSelectModule, FormsModule, ListCardComponent, MobileFooterComponent, BottomSheetComponent],
  templateUrl: './status-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './status-list.component.scss'
})
export class StatusListComponent implements OnInit {
  statuses: any[] = [];
  filteredStatuses: any[] = [];
  categoryFilter: string | null = null;
  searchText = '';
  mobileFiltersOpen = false;

  isLoading = true;
  rows = Array.from({ length: 5 }, (_, i) => i + 1);

  order = true;
  orderColName = 'code';
  selectedId = signal<any>(null);

  categories = [
    { value: 'PROCESS', label: 'PROCESS' },
    { value: 'ENTITY', label: 'ENTITY' }
  ];

  public appSettings = inject(AppSettings);
  private statusService = inject(StatusService);
  readonly perm = inject(PermissionService);

  @Output() selectEvent = new EventEmitter<any>();

  ngOnInit(): void {
    this.loadStatuses();
  }

  loadStatuses() {
    this.isLoading = true;
    this.statusService.get().subscribe({
      next: (res) => {
        this.statuses = res || [];
        this.applyFilters();
        this.isLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.isLoading = false;
      }
    });
  }

  applyFilters() {
    const term = (this.searchText || '').trim().toLowerCase();
    this.filteredStatuses = this.statuses.filter((s) => {
      if (this.categoryFilter && s.category !== this.categoryFilter) return false;
      if (!term) return true;
      return [s.name, s.slug, String(s.code)]
        .filter(Boolean)
        .some((v) => String(v).toLowerCase().includes(term));
    });
    this.applyOrder();
  }

  orderCol(col: string) {
    if (this.orderColName === col) {
      this.order = !this.order;
    } else {
      this.orderColName = col;
      this.order = true;
    }
    this.applyOrder();
  }

  applyOrder() {
    this.filteredStatuses.sort((a, b) => {
      const valA = a[this.orderColName];
      const valB = b[this.orderColName];

      if (typeof valA === 'string' && typeof valB === 'string') {
        return this.order ? valA.localeCompare(valB) : valB.localeCompare(valA);
      }
      return this.order ? (valA ?? 0) - (valB ?? 0) : (valB ?? 0) - (valA ?? 0);
    });
  }

  selectStatus(status: any) {
    this.selectedId.set(status.id);
    this.selectEvent.emit(status);
  }

  setCategoryFilter(value: string | null) {
    this.categoryFilter = value;
    this.applyFilters();
  }
}
